import React, {Component, PropTypes} from 'react';
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertToHTML } from 'draft-convert';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './richText.css'

class RichText extends Component {
    constructor(props) {
        super(props);        
      }
    render() {
        const { editorState, onEditorStateChange } = this.props;
        return (
          <Editor
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            editorClassName="editor-custom"
            onEditorStateChange={onEditorStateChange}
          />
        )
    }
}
export default RichText


// WEBPACK FOOTER //
// ./src/components/Misc/RichText/index.jsx